import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { setProductSuggestion } from 'src/state/users'
import { LanguageCode, MenuProduct } from '@meniudigital/shared'
import Button from 'src/global/Button'
import ProductPicker from './ProductPicker'
import Product from './ProductPicker/Product'
import { productsSelector } from 'src/state/selectors'
import Setting from '../Setting'

export default function ProductSuggestionSetting() {
  const dispatch = useDispatch()
  const { user } = useSelector((state: State) => state.users)
  const { list: products } = useSelector(productsSelector)

  if (!user) {
    return null
  }

  const toggleProductSuggestion = () => {
    const currentSuggestion = user?.activeProductSuggestion
    dispatch(setProductSuggestion({ isActive: !currentSuggestion?.isActive, productId: currentSuggestion?.productId || '' }))
  }

  const setSuggestedProductId = (newProductId: string | undefined) => {
    const currentSuggestion = user?.activeProductSuggestion
    if (!newProductId) {
      dispatch(setProductSuggestion({ isActive: false, productId: '' }))
    } else {
      dispatch(setProductSuggestion({ isActive: currentSuggestion?.isActive || false, productId: newProductId }))
    }
  }

  const isSuggestionActive = Boolean(user?.activeProductSuggestion?.isActive)
  const suggestedProduct = products.find(x => x.id === user?.activeProductSuggestion?.productId)

  return (
    <>
      <div className="setting-question">Dorești să evidențiezi un produs la deschiderea meniului?</div>
      <Setting
        title="Recomandarea Noastră de Astăzi"
        iconPath="/icons/like.png"
        isEnabled={isSuggestionActive}
        onToggle={toggleProductSuggestion}
        toggleTexts={{ on: 'Activă', off: '' }}
        infoText="Produsul ales va fi afișat clienților la deschiderea meniului."
        body={
          <>
            {suggestedProduct && (
              <Product
                query=""
                product={suggestedProduct}
                languageCode={LanguageCode.Romanian}
                inPartyMode={Boolean(user?.inPartyMode)}
                user={user}
                onRemoveClick={() => setSuggestedProductId(undefined)}
              />
            )}
            <Button
              variant="as-text"
              text={suggestedProduct ? 'Schimbă produsul...' : 'Alege produs...'}
              onClick={() => window.openProductPicker()}
            />
          </>
        }
        withBullet
      />
      <ProductPicker onProductPick={(product: MenuProduct) => setSuggestedProductId(product.id)} />
    </>
  )
}
